import script from "./UserDashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./UserDashboardPage.vue?vue&type=style&index=0&id=566279bb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-566279bb"]])

export default __exports__